import type { MenuItem } from '@/types';

/**
 * React Native Docs
 */
export const reactNativeDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/react-native/overview' },
  { label: 'Web SDK', path: '/sdk_ref/react-native/rn-web-sdk' },
  { label: 'Examples', path: '/sdk_ref/react-native/examples' },
];
